import { TableColumn } from '../model';
import { SortDirection } from '@wix/bex-core';

export const aColumn = <T>(
  property: keyof T,
  sortable = false,
  defaultSortDirection?: SortDirection,
) =>
  ({
    id: property,
    title: property,
    sortable,
    defaultSortDirection,
    render: (rowData) => rowData[property],
  } as TableColumn<T>);
